import type Window from '../../common/window.d.ts';
import { YleApiCredentials } from '../../common/types';

export const getClientYleApiCredentials = (): YleApiCredentials => {
  const authKeys: YleApiCredentials = {
    id: (window as Window).yleLeanback.clientYleApiCredentials.id,
    key: (window as Window).yleLeanback.clientYleApiCredentials.key,
  };
  if (!authKeys) {
    throw new Error(
      `No client YleApiCredentials found from window.yleLeanback`
    );
  }
  return authKeys;
};
